import React from 'react';

const ScheduleIcon = ({
  showNewUI = false,
  fillColor = '#2961fa',
  size = '40',
}) =>
  showNewUI ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 17 18"
      fill="none">
      <path
        d="M5.00002 0.666626V3.16663"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 0.666626V3.16663"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.25002 6.57495H15.4167"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8333 6.08329V13.1666C15.8333 15.6666 14.5833 17.3333 11.6667 17.3333H5.00001C2.08334 17.3333 0.833344 15.6666 0.833344 13.1666V6.08329C0.833344 3.58329 2.08334 1.91663 5.00001 1.91663H11.6667C14.5833 1.91663 15.8333 3.58329 15.8333 6.08329Z"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4123 10.4167H11.4197"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4123 12.9167H11.4197"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.32958 10.4167H8.33707"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.32958 12.9167H8.33707"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.24526 10.4167H5.25275"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.24526 12.9167H5.25275"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      id="Schedule"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 72 72">
      <circle
        id="Ellipse_706"
        data-name="Ellipse 706"
        cx="36"
        cy="36"
        r="36"
        fill="rgba(41,97,250,0)"
      />
      <g id="Layer_2" data-name="Layer 2" transform="translate(18.075 17.615)">
        <path
          id="Path_65844"
          data-name="Path 65844"
          d="M438.793,36.081H417.074a6.72,6.72,0,0,1-6.784-6.654V10.771a6.59,6.59,0,0,1,1.985-4.71,6.852,6.852,0,0,1,4.8-1.951h21.719a6.852,6.852,0,0,1,4.8,1.951,6.59,6.59,0,0,1,1.985,4.71V29.427A6.72,6.72,0,0,1,438.793,36.081ZM417.074,6.8A4.034,4.034,0,0,0,413,10.771V29.427a4.04,4.04,0,0,0,4.072,3.994h21.719a4.04,4.04,0,0,0,4.072-3.994V10.771A4.034,4.034,0,0,0,438.793,6.8Z"
          transform="translate(-410.29 -1.188)"
          fill={fillColor}
        />
        <path
          id="Path_65845"
          data-name="Path 65845"
          d="M448.695,39.947h-5.431a1.373,1.373,0,0,1-1.373-1.373V33.163a1.373,1.373,0,0,1,1.373-1.373h5.431a1.373,1.373,0,0,1,1.373,1.373v5.431A1.373,1.373,0,0,1,448.695,39.947ZM444.623,37.2h2.712V34.523h-2.712Z"
          transform="translate(-420.192 -10.362)"
          fill={fillColor}
        />
        <path
          id="Path_65846"
          data-name="Path 65846"
          d="M436.28,18.747H411.313a1.245,1.245,0,0,1-1.053-1.373A1.245,1.245,0,0,1,411.313,16H436.28a1.245,1.245,0,0,1,1.053,1.373A1.245,1.245,0,0,1,436.28,18.747Z"
          transform="translate(-406.156 -5.125)"
          fill={fillColor}
        />
        <path
          id="Path_65847"
          data-name="Path 65847"
          d="M425.473,8.327A1.373,1.373,0,0,1,424.1,6.954V1.543a1.373,1.373,0,1,1,2.747,0V6.968a1.373,1.373,0,0,1-1.373,1.36Z"
          transform="translate(-414.617 0.046)"
          fill={fillColor}
        />
        <path
          id="Path_65848"
          data-name="Path 65848"
          d="M445.235,8.229a1.373,1.373,0,0,1-1.373-1.373V1.445a1.373,1.373,0,1,1,2.712,0V6.869a1.373,1.373,0,0,1-1.339,1.36Z"
          transform="translate(-420.805 0.145)"
          fill={fillColor}
        />
      </g>
    </svg>
  );

export default ScheduleIcon;
